import { Link } from "react-router-dom";
import { SERVICES } from "@/lib/data";
import { useReveal } from "@/hooks/useReveal";

export const Services = ({ limit, showCta = true, hideHeading = false }) => {
  const titleRef = useReveal();
  const list = limit ? SERVICES.slice(0, limit) : SERVICES;
  return (
    <section id="services" className="py-12 lg:py-16 relative bg-white/[0.015] border-y border-white/5">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        {!hideHeading && (
          <div ref={titleRef} className="reveal max-w-3xl mb-12">
            <span className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--accent))] font-semibold">
              Vores Services
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold mt-3 leading-[1.05]">
              Alt hvad du skal bruge for at{" "}
              <span className="italic font-light text-white/60">vækste digitalt.</span>
            </h2>
            <p className="mt-5 text-white/60 max-w-2xl text-base">
              Vi bygger skræddersyede digitale kunderejser der engagerer din målgruppe og konverterer dem til betalende kunder.
            </p>
          </div>
        )}

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 rounded-3xl overflow-hidden border border-white/10">
          {list.map((s, i) => (
            <ServiceCard key={s.slug} item={s} index={i} />
          ))}
        </div>

        {showCta && limit && (
          <div className="mt-10 text-center">
            <Link
              to="/services"
              className="btn-pop inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/15 text-white/90 hover:border-[hsl(var(--accent))] hover:text-[hsl(var(--accent))]"
            >
              Se alle services
              <span aria-hidden>→</span>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

const ServiceCard = ({ item, index }) => {
  const ref = useReveal();
  return (
    <Link
      ref={ref}
      to="/kontakt"
      data-testid={`service-card-${item.slug}`}
      className="reveal group relative bg-[hsl(var(--bg))] p-7 lg:p-9 hover:bg-[hsl(var(--bg-card))] transition-colors duration-500 cursor-pointer block"
      style={{ transitionDelay: `${index * 50}ms` }}
    >
      <div className="flex items-start justify-between mb-6">
        <span className="font-display text-xs font-semibold tracking-widest text-[hsl(var(--accent))]/80">
          {String(index + 1).padStart(2, "0")}
        </span>
        <span className="h-9 w-9 rounded-full border border-white/15 grid place-items-center text-white/60 group-hover:border-[hsl(var(--accent))] group-hover:text-[hsl(var(--accent))] group-hover:rotate-45 transition-all duration-500">
          →
        </span>
      </div>
      <h3 className="font-display text-2xl font-bold leading-tight group-hover:text-[hsl(var(--accent))] transition-colors">{item.title}</h3>
      <p className="mt-3 text-sm text-white/60 leading-relaxed">{item.desc}</p>

      <ul className="mt-6 space-y-2.5">
        {item.bullets.map((b) => (
          <li key={b} className="flex items-start gap-2.5 text-sm text-white/75">
            <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-[hsl(var(--accent))] flex-shrink-0" />
            {b}
          </li>
        ))}
      </ul>

      <div className="mt-6 inline-flex items-center gap-2 text-xs font-semibold text-[hsl(var(--accent))] opacity-0 group-hover:opacity-100 transition-opacity">
        Få en gratis analyse
        <span aria-hidden>→</span>
      </div>
    </Link>
  );
};
